import { useMutation, useQueryClient } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";
import type {
  BookingCancelRequest,
  BookingCancellationResponse,
} from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * Commit one server-issued quote. The caller owns the idempotency key so an
 * ambiguous response can retry the exact operation without a duplicate refund.
 */
export function useCancelBooking(facilityId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation<
    BookingCancellationResponse,
    unknown,
    { bookingId: string; request: BookingCancelRequest }
  >({
    mutationFn: ({ bookingId, request }) =>
      facilityApi.cancelBooking(bookingId, request),
    onSuccess: (_response, { bookingId }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.booking.myBookings(facilityId ?? ""),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.booking.allBookings(),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.booking.detail(bookingId),
      });
      void queryClient.invalidateQueries({
        queryKey: ["booking", "availability", facilityId ?? ""],
      });
    },
  });
}
